import { useGetProfiles } from '@/hooks/api';

export function useGetProfile(sa: string, id: string, enabled?: boolean) {
  const { data, ...rest } = useGetProfiles(sa, enabled);
  const profile = data?.find((p) => p.ProfileId === id);
  return { ...rest, data: profile };
}
